import get from 'lodash/get';
import * as tagPageActions from '../../action_creators/tag/tag_page_action_creators';
import log from '../../../services/logger_service';

import tagVideoActions from './async_tag_video_actions';
import tagAllFeedActions from './async_tag_all_feed_actions';
import tagScrollingModuleActions from './async_tag_scrolling_module_actions';
import asyncTagPromoBannerActions from './async_tag_promo_banner_actions';

import tagPromoterChannelFcWorks from './async_tag_promoter_channel_fc_works_actions';
import tagFeaturedFeedActions from './async_tag_featured_feed_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import asyncFeaturedSponsoredCardActions from '../homepage/async_featured_sponsored_card_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

import asyncMagazineIssuePostsActions from '../magazine/async_magazine_issue_posts_actions';
import asyncSupertagsActions from '../async_supertags_actions';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagPageActions.tagPageLoading({}, store));
    let actions = [
      tagFeaturedFeedActions(params, store)(dispatch),
      asyncFeaturedSponsoredCardActions(params, store)(dispatch),
      asyncTagPromoBannerActions(params, store)(dispatch),
      tagScrollingModuleActions(params, store)(dispatch),
      tagVideoActions(params, store)(dispatch),
      tagAllFeedActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch),
      tagPromoterChannelFcWorks(params, store)(dispatch),
      asyncSupertagsActions(params, store)(dispatch)
    ];

    if (params.tag === 'premium') {
      actions = [
        tagFeaturedFeedActions(params, store)(dispatch),
        tagAllFeedActions(params, store)(dispatch),
        asyncSupertagsActions(params, store)(dispatch)
      ];
    }

    if (params.magazine) {
      actions.push(asyncMagazineIssuePostsActions(params, store)(dispatch));
    }

    return Promise.all(actions)
      .then(function handlePostDetailData() {
        dispatch(tagPageActions.tagPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(tagPageActions.tagPageLoadError(err, store));
      });
  };
}
